import React from 'react';
import IFrame from '@/components/iframe';
import env from '@/env';

export default function PromotionTools() {
  return <IFrame src={env.QYPT_DOMAIN} />;
}
